import React from 'react';

import { TabLoader, TabConfig, addTab, removeAll } from 'wdna-components/lib/tabs';

const Readings: React.LazyExoticComponent<any> = React.lazy(() => import('../components/Readings'));

export default class Loader extends TabLoader {
  /* Override tab loader method */
  public loadTab = (tabId?: string | number): void => {
    const access: boolean = true;
    if (access) {
      window.store.dispatch(removeAll());

      const tabData: TabConfig = {
        id: String(tabId || window.getStr()),
        active: true,
        title: 'Sensors | Reads',
        component: Readings,
        props: {
          report: 'SENSOR_READS',
          title: 'Readings',
        },
      };

      window.store.dispatch(addTab(tabData));
    }
  };
}
